module.exports = __webpack_public_path__ + "static/media/keyman-database-logo-white.317c2d28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyman-database-logo-white.svg
// module id = 520
// module chunks = 1